var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tabType)?_c('customerChildDetail',{attrs:{"tabType":_vm.tabType}}):_c('customerDetail',{attrs:{"tabName":_vm.activeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }